import { ref } from "vue";

const visible = ref(false);
const message = ref("");
const type = ref("default");
const resolveCallback = ref(null);
const options = ref({});
// let timeout = null;

export function useBaseProdDialog() {
  const hideBaseProdDialog = () => {
    visible.value = false; // visible만 false로 변경
  };

  const showBaseProdDialog = (msg, opts = {}) => {
    // 이전 타이머가 있다면 제거
    // if (timeout) {
    //   clearTimeout(timeout);
    //   timeout = null;
    // }

    // 새 메시지로 업데이트하고 즉시 표시
    message.value = msg;
    type.value = opts.type || "default";
    visible.value = true;
    options.value = opts;
    return new Promise((resolve) => {
      resolveCallback.value = resolve;
    });

    // 새로운 타이머 설정
    // timeout = setTimeout(() => {
    //   hideBaseProdDialog();
    //   timeout = null;
    // }, options.duration || 3000);
  };

  const confirmAction = () => {
    if (resolveCallback.value) {
      resolveCallback.value(true);
    }
    visible.value = false;
  };

  const cancelAction = () => {
    if (resolveCallback.value) {
      resolveCallback.value(false);
    }
    visible.value = false;
  };

  return {
    visible,
    message,
    type,
    options,
    showBaseProdDialog,
    hideBaseProdDialog,
    confirmAction,
    cancelAction,
  };
}
